import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Privacypolicy from "./sections/Privacypolicy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      
      <Footer />
    </div>;
}